import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../Redux/Store";

interface RoleProtectedRouteProps {
    allowedRoles: string[];
}

const RoleProtectedRoute: React.FC<RoleProtectedRouteProps> = ({ allowedRoles }) => {
    const { myInfo } = useSelector((state: RootState) => state.user);

    // Extract the specific role of the user, handle case insensitivity
    const userRole = myInfo?.userType?.toUpperCase();
    const normalizedAllowedRoles = allowedRoles.map((role) => role.toUpperCase());

    if (!userRole) {
        // If the user role is not available in state, redirect to login
        return <Navigate to="/login" replace />;
    }

    if (!normalizedAllowedRoles.includes(userRole)) {
        // If user's role is not authorized for this route, redirect to an unauthorized page or dashboard
        return <Navigate to="/dashboard" replace />;
    }

    // If authorized, render the child routes
    return <Outlet />;
};

export default RoleProtectedRoute;
